import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Lightbox } from 'ng-gallery/lightbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { Bank, BANKS } from './statelist';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';

export interface BankGroup {
  name: string;
  banks: Bank[];
}
// new code

export interface PeriodicElement {
  question: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
  { question: 'What is the ideal climatic condition to grow coconut tree?' },
];
// new code end
@Component({
  selector: 'app-discussion-board',
  templateUrl: './discussion-board.component.html',
  styleUrls: ['./discussion-board.component.scss'],
})
export class DiscussionBoardComponent implements OnInit {
  displayedColumns: string[] = ['question'];
  dataSource = ELEMENT_DATA;
  // new code end
  viewData = '';
  viewsOption = [
    { value: 'mostViewed', viewValue: 'Most Viewed' },
    { value: 'leastViewed', viewValue: 'Least Viewed' },
  ];

  likeData = '';
  likesOption = [
    { value: 'mostLiked', viewValue: 'Most Liked' },
    { value: 'leastLiked', viewValue: 'Least Liked' },
  ];

  replyData = '';
  replyOption = [
    { value: 'mostReplied', viewValue: 'Most Replied' },
    { value: 'leastReplied', viewValue: 'Least Replied' },
  ];

  role = '';
  roleOption = [
    { value: 'farmer', viewValue: 'Farmer' },
    { value: 'trader', viewValue: 'Trader' },
  ];

  listData = '';
  listOption = [
    { value: 'all', viewValue: 'All' },
    { value: 'flagged', viewValue: 'Flagged' },
    { value: 'removed', viewValue: 'Removed' },
  ];

  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };
  maxDate;
  minDate;
  sharedate;
  pageSize;

  statedata = [];
  districtdata = [];
  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(
    1
  );

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<
    Bank[]
  >(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  length;
  pageIndex;
  // new code for api integration for header data
  totalUserCount;
  avgDiscussionquestionCount: any = [];
  // for data list display
  DiscussionBoardDataList = [];
  exportcsvdata = false;
  public matChipArray = [];
  searchData = '';
  filterbyText = '';
  filterbyAppVersion = '';
  filterbystate = [];
  filterbydistrict = [];
  filterbylanguage = '';
  newDataList = [];
  newData;

  mostrecent;
  oldRating;
  highestRating;
  lowestRating;
  customDate = false;
  // discussionBoardDetail
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  //sorting table
  dataSourcelist;
  formdate = '';
  filterbyformdate = '';
  filterbytodayte = '';
  todayte = '';
  filterbynamedata = '';
  namedata = '';
  state = '';
  district = '';

  userlist = [];
  filterbymonthData = '';
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  datashow = true;
  apidata;
  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;

  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  datarole;
  totalcount;

  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';
  food_from_modal: string;
  userdata;
  dataSource1 = new MatTableDataSource<Element>([]);
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true })
  multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {}
  // edit post
  askquestionform: FormGroup;
  ngOnInit(): void {
    // edit post
    // this.askquestionform = this.fb.group({
    //   questionTitle: ['', [Validators.required]],
    //   quetionDiscription: ['', [Validators.required]],
    //   attachlink: ['', [Validators.pattern(this.reg)]],
    //   Image: ['', [Validators.required]],
    // });
    // end edit post

    this.getAlluser();
    this.getDiscussionboardHeader();
    setTimeout(() => {
      this.datarole = localStorage.getItem('postBy');
    }, 1000);
    // load the initial bank list
    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    // listen for search field value changes
    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });

    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });
    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.setToggleAllCheckboxState();
      });
  }

  rolebased = [{ role: 'Trader' }, { role: 'Farmer' }];
  selectable = true;
  roleData = '';
  phonedata = '';
  mandidata = '';
  removable = true;
  roledata = '';
  remove(index, tag): void {
    if (tag === 'name') {
      this.matChipArray.splice(index, 1);
      this.namedata = '';
    }

    if (tag === 'viewData') {
      this.matChipArray.splice(index, 1);
      this.viewData = '';
    }

    if (tag === 'likeData') {
      this.matChipArray.splice(index, 1);
      this.likeData = '';
    }

    if (tag === 'replyData') {
      this.matChipArray.splice(index, 1);
      this.replyData = '';
    }

    if (tag === 'listData') {
      this.matChipArray.splice(index, 1);
      this.listData = '';
    }
    if (tag === 'roleName') {
      this.matChipArray.splice(index, 1);
      this.roleName = '';
    }
    if (tag === 'role') {
      this.matChipArray.splice(index, 1);
      this.roledata = '';
    }
    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(
        (x) => removedState[0].name === 'State:' + x.stateName
      );
      val.splice(i, 1);
      this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      this.bankMultiCtrl.setValue(this.statedata);
    }
    if (tag === 'phone') {
      this.matChipArray.splice(index, 1);
      this.phonedata = '';
    }
    if (tag === 'district') {
      let removedDistrict: any = this.matChipArray.splice(index, 1);
      let val = JSON.parse(JSON.stringify(this.districtdata));
      let i = val.findIndex(
        (x) => removedDistrict[0].name === 'District:' + x.districtName
      );
      val.splice(i, 1);
      this.districtMultiCtrl.setValue(val);
    }
    if (tag === 'phone') {
      this.matChipArray.splice(index, 1);
      this.phonedata = '';
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
      this.startdata = '';
      this.enddata = '';
    }
    if (tag === 'stateName') {
      this.matChipArray.splice(index, 1);
      this.stateName = '';
    }

    this.applyfilter(false);
  }

  suche() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search State';
    }, 5);
  }

  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll('#search1 div input')[1] as any).placeholder =
        'Search District';
    }, 5);
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter(
      (bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1
    );
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter(
      (item: any) => item.toLowerCase().indexOf(search) > -1
    );
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach((el) => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict =
        filteredLength > 0 &&
        filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict =
        filteredLength > 0 &&
        filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }
  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }

  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll('#search1>div')[1] as any).innerText =
          'not found';
      }, 10);
    }
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {
    } else {
      this.bankMultiCtrl.value.forEach((element) => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }

  clearFilter() {
    this.spinner.show();
    this.getAlluser();
    window.location.reload();
  }

  askPage() {
    this.router.navigate(['/discussionboard-ask-page']);
  }
  listPage() {
    this.router.navigate(['discussionboard-details']);
  }
  editNews = false;
  listPage1() {
    this.editNews = true;
    this.router.navigate(['discussionboard']);
  }
  flagClick(id: any) {
    localStorage.setItem('postId', id);
    this.router.navigate(['/discussionboard-details']);
  }

  startdata;
  enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }
  // start
  filterbysharedate = '';
  filterbydistrictName = '';
  districtName = '';
  filterbyrole = '';
  filterbyquestion = '';
  filterbystateName = '';
  stateName = '';
  filterbyviews = '';
  filterbylikes = '';
  filterbyreplies = '';
  filterbylistoptions = '';
  applyFilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = [];
    this.statedata.forEach((ele: any) => {
      totalState.push(ele.stateName);
    });

    if (
      checkEmpty &&
      !this.searchData &&
      !this.roledata &&
      totalState.length == 0 &&
      this.districtdata.length == 0 &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate &&
      !this.stateName &&
      !this.viewData &&
      !this.likeData &&
      !this.replyData &&
      !this.listData
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbynamedata = this.namedata;
      this.filterbystate = totalState;
      this.filterbydistrict = this.districtdata;
      this.filterbyrole = this.roledata;
      this.filterbystateName = this.stateName;
      this.filterbyviews = this.viewData;
      this.filterbylikes = this.likeData;
      this.filterbyreplies = this.replyData;
      this.filterbyflagPost = this.listData;

      let indexrole = this.matChipArray.findIndex((x) => x.tag === 'roles');
      let indexstateName = this.matChipArray.findIndex(
        (x) => x.tag === 'stateName'
      );

      let indexnamedata = this.matChipArray.findIndex(
        (x) => x.tag === 'namedata'
      );
      let indexstate = this.matChipArray.findIndex((x) => x.tag === 'state');
      let indexdistrictdata = this.matChipArray.findIndex(
        (x) => x.tag === 'district'
      );
      this.filterbyformdate = this.formdate;
      this.filterbytodayte = this.datePipe.transform(
        this.todayte,
        'yyyy/MM/dd hh:mm:ss'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      let indexviews = this.matChipArray.findIndex((x) => x.tag === 'viewData');
      let indexlikes = this.matChipArray.findIndex((x) => x.tag === 'likeData');
      let indexreplies = this.matChipArray.findIndex(
        (x) => x.tag === 'replyData'
      );
      let indexflagPost = this.matChipArray.findIndex(
        (x) => x.tag === 'listData'
      );
      if (this.listData != '') {
        if (indexflagPost > -1) {
          this.matChipArray[indexflagPost].name =
            'listData' + ':' + this.listData;
        } else {
          if (this.listData != '' && this.listData != undefined) {
            this.matChipArray.push({
              name: 'listData' + ':' + this.listData,
              tag: 'listData',
              flag: true,
            });
          }
        }
      }

      if (this.replyData != '') {
        if (indexreplies > -1) {
          this.matChipArray[indexreplies].name =
            'replyData' + ':' + this.replyData;
        } else {
          if (this.replyData != '' && this.replyData != undefined) {
            this.matChipArray.push({
              name: 'replyData' + ':' + this.replyData,
              tag: 'replyData',
              flag: true,
            });
          }
        }
      }

      if (this.likeData != '') {
        if (indexlikes > -1) {
          this.matChipArray[indexlikes].name = 'likeData' + ':' + this.likeData;
        } else {
          if (this.likeData != '' && this.likeData != undefined) {
            this.matChipArray.push({
              name: 'likeData' + ':' + this.likeData,
              tag: 'likeData',
              flag: true,
            });
          }
        }
      }

      if (this.viewData != '') {
        if (indexviews > -1) {
          this.matChipArray[indexviews].name = 'viewData' + ':' + this.viewData;
        } else {
          if (this.viewData != '' && this.viewData != undefined) {
            this.matChipArray.push({
              name: 'viewData' + ':' + this.viewData,
              tag: 'viewData',
              flag: true,
            });
          }
        }
      }

      if (this.stateName != '') {
        if (indexstateName > -1) {
          this.matChipArray[indexstateName].name =
            'State' + ':' + this.stateName;
        } else {
          if (this.stateName != '' && this.stateName != undefined) {
            this.matChipArray.push({
              name: 'State' + ':' + this.stateName,
              tag: 'stateName',
              flag: true,
            });
          }
        }
      }
      if (this.namedata != '') {
        if (indexnamedata > -1) {
          this.matChipArray[indexnamedata].name = 'Name' + ':' + this.namedata;
        } else {
          if (this.namedata != '' && this.namedata != undefined) {
            this.matChipArray.push({
              name: 'Name' + ':' + this.namedata,
              tag: 'name',
              flag: true,
            });
          }
        }
      }
      if (totalState != null) {
        totalState.forEach((ele) => {
          this.matChipArray.push({
            name: 'State' + ':' + ele,
            tag: 'state',
            flag: true,
          });
        });
      }
      if (this.roledata != '') {
        if (indexrole > -1) {
          this.matChipArray[indexrole].name = 'Role' + ':' + this.roledata;
        } else {
          if (this.roledata != '' && this.roledata != undefined) {
            this.matChipArray.push({
              name: 'Role' + ':' + this.roledata,
              tag: 'role',
              flag: true,
            });
          }
        }
      }

      if (this.districtdata != null) {
        this.districtdata.forEach((ele) => {
          this.matChipArray.push({
            name: 'District' + ':' + ele,
            tag: 'district',
            flag: true,
          });
        });
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('DD/MM/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('DD/MM/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('DD/MM/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('DD/MM/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }
      var postdata = {
        postBy: this.filterbyrole,
        fromDate: this.startdata,
        toDate: this.enddata,
        search: this.filterbyText,
        status: this.statusdata,
        totalReplies: this.replies,
        // "likes": this.likes,
        // "view": this.views,
        likes: this.filterbylikes,
        view: this.filterbyviews,
        replies: this.filterbyreplies,
        flagPost: this.filterbyflagPost,
        role: this.filterbyrole,
        states: this.filterbystateName,
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService
        .getDiscussionBoardDataList(postdata)
        .subscribe((data) => {
          // this.userdata = data
          // this.userlist = this.userdata.result.data.list;
          // this.paginationProperty = this.userdata.result.data
          // this.length = this.paginationProperty.totalItems;
          // this.previousPageIndex = this.paginationProperty.previousPageIndex;
          // this.hasNextPage = this.paginationProperty.hasNextPage;
          // this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          // this.pageIndex = this.paginationProperty.pageNumber;
          // this.totalPages = this.paginationProperty.totalPages;
          // this.dataSource1 = new MatTableDataSource<Element>(this.userdata.result.data.list);

          // this.dataSource1.sort = this.sort;
          // this.spinner.hide();
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.userlist.forEach(
            (value) => (value.postDate = value.postDate.slice(0, 10))
          );
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;

          this.dataSource1 = new MatTableDataSource(this.userlist);
          this.dataSource1.sort = this.sort;
          //  this.dataSource.paginator = this.paginator;
          this.spinner.hide();
        });
    }
  }
  // end

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }

  dialogresult;
  mainresult;

  // start

  /*.......................................................GET ALL USER......................................................... */
  getAlluser() {
    this.spinner.show();
    var postdata = {
      postBy: '',
      name: '',
      roles: '',
      state: this.filterbystate.join(','),
      district: this.districtdata.join(','),
      fromDate: this.startdata,
      todate: this.enddata,
      search: this.filterbyText,
      pageNumber: 0,
      pageSize: 10,
    };
    this._userService.getDiscussionBoardDataList(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.userlist.forEach(
        (value) => (value.postDate = value.postDate.slice(0, 10))
      );
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;

      this.dataSource1 = new MatTableDataSource(this.userlist);
      this.dataSource1.sort = this.sort;
      //  this.dataSource.paginator = this.paginator;
      this.spinner.hide();

      // this.paginationProperty = this.userdata.result.data
      // this.length = this.paginationProperty.totalItems;
      // this.totalcount = this.paginationProperty.totalItems;
      // this.previousPageIndex = this.paginationProperty.previousPageIndex;
      // this.hasNextPage = this.paginationProperty.hasNextPage;
      // this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      // this.pageIndex = this.paginationProperty.pageNumber
      // this.dataSource1 = new MatTableDataSource(this.userlist);
      // this.dataSource1.paginator = this.paginator;
      // this.dataSource1.sort = this.sort;
      // setTimeout(() => this.dataSource1.sort = this.sort);
      // this.spinner.hide();
    });
  }
  // apply filter
  views = '';
  likes = '';
  replies = '';
  roles = '';
  postedby = '';
  flagPost = '';
  filterbyflagPost = '';
  productTypeName = '';
  filterbyproduct = '';
  filterbystatus: '';
  statusdata: '';
  filterbyvariety = '';
  varietyName = '';
  filterbyquantity = '';
  filterbyprice = '';
  filterbytext = '';
  filterbyroleName = '';
  roleName = '';
  formdate1 = this.datePipe.transform(
    this.form.controls.start.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  todayte1 = this.datePipe.transform(
    this.form.controls.end.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  applyfilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = [];
    if (this.statedata) {
      this.statedata.forEach((ele: any) => {
        totalState.push(ele.stateName);
      });
    }

    if (
      checkEmpty &&
      !this.views &&
      !this.likes &&
      !this.searchData &&
      !this.replies &&
      totalState.length == 0 &&
      this.districtdata.length == 0 &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate &&
      !this.views &&
      !this.likes &&
      !this.replies &&
      !this.flagPost &&
      !this.viewData &&
      !this.likeData &&
      !this.replyData &&
      !this.listData
    ) {
      // alert('Please provide input first');
    } else {
      this.filterbystate = totalState;
      this.filterbydistrict = this.districtdata;
      // this.views = this.views;
      // this.likes = this.likes;
      this.filterbyviews = this.viewData;
      this.filterbylikes = this.likeData;
      this.filterbyreplies = this.replyData;
      this.exportcsvdata = true;
      // this.replies = this.replies;
      this.postedby = this.postedby;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;
      this.filterbystatus = this.statusdata;
      this.filterbyrole = this.roleData;
      this.filterbytext = this.searchData;
      this.filterbyroleName = this.roleName;
      this.filterbyflagPost = this.listData;

      let indexproduct = this.matChipArray.findIndex(
        (x) => x.tag === 'productTypeName'
      );
      let indexvariety = this.matChipArray.findIndex(
        (x) => x.tag === 'varietyName'
      );
      let indexstatus = this.matChipArray.findIndex(
        (x) => x.tag === 'statusdata'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      let indexsharequantity = this.matChipArray.findIndex(
        (x) => x.tag === 'quantity'
      );
      let indexprice = this.matChipArray.findIndex(
        (x) => x.tag === 'priceValue'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexroleName = this.matChipArray.findIndex(
        (x) => x.tag === 'roleName'
      );
      let indexviews = this.matChipArray.findIndex((x) => x.tag === 'viewData');
      let indexlikes = this.matChipArray.findIndex((x) => x.tag === 'likeData');
      let indexreplies = this.matChipArray.findIndex(
        (x) => x.tag === 'replyData'
      );
      let indexflagPost = this.matChipArray.findIndex(
        (x) => x.tag === 'listData'
      );
      if (this.listData != '') {
        if (indexflagPost > -1) {
          this.matChipArray[indexflagPost].name =
            'listData' + ':' + this.listData;
        } else {
          if (this.listData != '' && this.listData != undefined) {
            this.matChipArray.push({
              name: 'listData' + ':' + this.listData,
              tag: 'listData',
              flag: true,
            });
          }
        }
      }

      if (this.replyData != '') {
        if (indexreplies > -1) {
          this.matChipArray[indexreplies].name =
            'replyData' + ':' + this.replyData;
        } else {
          if (this.replyData != '' && this.replyData != undefined) {
            this.matChipArray.push({
              name: 'replyData' + ':' + this.replyData,
              tag: 'replyData',
              flag: true,
            });
          }
        }
      }

      if (this.likeData != '') {
        if (indexlikes > -1) {
          this.matChipArray[indexlikes].name = 'likeData' + ':' + this.likeData;
        } else {
          if (this.likeData != '' && this.likeData != undefined) {
            this.matChipArray.push({
              name: 'likeData' + ':' + this.likeData,
              tag: 'likeData',
              flag: true,
            });
          }
        }
      }
      if (this.viewData != '') {
        if (indexviews > -1) {
          this.matChipArray[indexviews].name = 'viewData' + ':' + this.viewData;
        } else {
          if (this.viewData != '' && this.viewData != undefined) {
            this.matChipArray.push({
              name: 'viewData' + ':' + this.viewData,
              tag: 'viewData',
              flag: true,
            });
          }
        }
      }

      if (this.roleName != '') {
        if (indexroleName > -1) {
          this.matChipArray[indexroleName].name = 'Role' + ':' + this.roleName;
        } else {
          if (this.roleName != '' && this.roleName != undefined) {
            this.matChipArray.push({
              name: 'Role' + ':' + this.roleName,
              tag: 'roleName',
              flag: true,
            });
          }
        }
      }

      if (totalState != null) {
        totalState.forEach((ele) => {
          this.matChipArray.push({
            name: 'State' + ':' + ele,
            tag: 'state',
            flag: true,
          });
        });
      }

      if (this.districtdata != null) {
        this.districtdata.forEach((ele) => {
          this.matChipArray.push({
            name: 'District' + ':' + ele,
            tag: 'district',
            flag: true,
          });
        });
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('DD/MM/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('DD/MM/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('DD/MM/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('DD/MM/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }

      if (this.productTypeName != '') {
        if (indexproduct > -1) {
          this.matChipArray[indexproduct].name =
            'Product' + ':' + this.productTypeName;
        } else {
          if (this.productTypeName != '' && this.productTypeName != undefined) {
            this.matChipArray.push({
              name: 'Product' + ':' + this.productTypeName,
              tag: 'productTypeName',
              flag: true,
            });
          }
        }
      }

      if (this.varietyName != '') {
        if (indexvariety > -1) {
          this.matChipArray[indexvariety].name =
            'Variety' + ':' + this.varietyName;
        } else {
          if (this.varietyName != '' && this.varietyName != undefined) {
            this.matChipArray.push({
              name: 'Variety' + ':' + this.varietyName,
              tag: 'varietyName',
              flag: true,
            });
          }
        }
      }

      if (this.statusdata != '') {
        if (indexstatus > -1) {
          this.matChipArray[indexstatus].name =
            'Product' + ':' + this.statusdata;
        } else {
          if (this.statusdata != '' && this.statusdata != undefined) {
            this.matChipArray.push({
              name: 'Status' + ':' + this.statusdata,
              tag: 'statusdata',
              flag: true,
            });
          }
        }
      }

      var postdata = {
        postBy: '',
        name: '',
        view: this.filterbyviews,
        likes: this.filterbylikes,
        replies: this.filterbyreplies,
        flagPost: this.filterbyflagPost,
        roles: this.filterbyroleName,
        states: this.filterbystateName,
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbytext,
        pageNumber: 0,
        pageSize: 10,
      };
      this._userService
        .getDiscussionBoardDataList(postdata)
        .subscribe((data) => {
          // this.userdata = data
          // this.userlist = this.userdata.result.data.list;
          // this.userlist.forEach((value) => value.postDate = value.postDate.slice(0, 10))
          // this.paginationProperty = this.userdata.result.data
          // this.length = this.paginationProperty.totalItems;
          // this.totalcount = this.paginationProperty.totalItems;
          // this.previousPageIndex = this.paginationProperty.previousPageIndex;
          // this.hasNextPage = this.paginationProperty.hasNextPage;
          // this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          // this.pageIndex = this.paginationProperty.pageNumber
          // this.dataSource1 = new MatTableDataSource(this.userlist);
          // this.dataSource1.paginator = this.paginator;
          // this.dataSource1.sort = this.sort;
          // setTimeout(() => this.dataSource1.sort = this.sort);
          // this.spinner.hide();
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.userlist.forEach(
            (value) => (value.postDate = value.postDate.slice(0, 10))
          );
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;

          this.dataSource1 = new MatTableDataSource(this.userlist);
          this.dataSource1.sort = this.sort;
          //  this.dataSource.paginator = this.paginator;
          this.spinner.hide();
        });
    }
  }

  // apply filter end

  // pagination

  openDialogexport1(): void {
    const dialogRef = this.dialog.open(DiscussionBoardExportData, {
      width: '60%',
      height: '53%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;

      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyFilter(true);
              var postdata = {
                fromdate: this.startdata,
                todate: this.enddata,
                search: this.filterbytext,
                state: this.filterbystate.join(','),
                district: this.districtdata.join(','),
                view: this.filterbyviews,
                likes: this.filterbylikes,
                replies: this.filterbyreplies,
                flagPost: this.filterbyflagPost,
                // "view": this.views,
                // "likes": this.likes,
                // "replies": "",
                // "flagPost": "",
                role: this.filterbyrole,
                roles: this.filterbyroleName,
                reportKeyList: Result,
              };
              this._userService
                .getDiscussionBoardDataListReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_discussionboardlist.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            } else {
              postdata = {
                roles: this.filterbyroleName,
                fromdate: '',
                todate: '',
                search: '',
                state: this.filterbystate.join(','),
                district: this.districtdata.join(','),
                view: '',
                likes: '',
                replies: '',
                flagPost: '',
                role: '',
                reportKeyList: Result,
              };
              this._userService
                .getDiscussionBoardDataListReport(postdata)
                .subscribe((data) => {
                  this.apidata = data;
                  const blob = new Blob([this.apidata], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  });
                  const url = window.URL.createObjectURL(blob);
                  // window.open(url);
                  var anchor = document.createElement('a');
                  anchor.download = 'PKF_discussionboardlist.xlsx';
                  anchor.href = url;
                  anchor.click();
                });
            }
          } else {
            this.openDialogexport1();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport1();
        }
      }
    });
  }
  // end
  // pagination
  public getServerData(event?: PageEvent) {
    // this.getAlluser();
    // this.spinner.show();/* Commented by shivam modi */
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {
      this.applyfilter(true);
      var postdata = {
        fromdate: this.startdata,
        todate: this.enddata,
        search: this.filterbytext,
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        view: this.filterbyviews,
        likes: this.filterbylikes,
        replies: this.filterbyreplies,
        flagPost: this.filterbyflagPost,
        // "view": this.views,
        // "likes": this.likes,
        // "replies": "",
        // "flagPost": "",
        role: this.filterbyrole,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };
      this._userService
        .getDiscussionBoardDataList(postdata)
        .subscribe((data) => {
          // this.userdata = data
          // this.userlist = this.userdata.result.data.list
          // this.paginationProperty = this.userdata.result.data
          // this.length = this.paginationProperty.totalItems
          // this.previousPageIndex = this.paginationProperty.previousPageIndex;
          // this.hasNextPage = this.paginationProperty.hasNextPage;
          // this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          // this.pageIndex = this.paginationProperty.pageNumber
          // this.dataSource1 = new MatTableDataSource(this.userlist);
          // this.dataSource1.sort = this.sort;
          // this.spinner.hide();
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.userlist.forEach(
            (value) => (value.postDate = value.postDate.slice(0, 10))
          );
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;

          this.dataSource1 = new MatTableDataSource(this.userlist);
          this.dataSource1.sort = this.sort;
          //  this.dataSource.paginator = this.paginator;
          this.spinner.hide();
        });
    } else {
      var postdata = {
        fromdate: this.startdata,
        todate: this.enddata,
        search: '',
        state: this.filterbystate.join(','),
        district: this.districtdata.join(','),
        view: this.views,
        likes: this.likes,
        replies: '',
        flagPost: '',
        role: this.filterbyrole,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };
      this._userService
        .getDiscussionBoardDataList(postdata)
        .subscribe((data) => {
          // this.userdata = data
          // this.userlist = this.userdata.result.data.list
          // this.paginationProperty = this.userdata.result.data
          // this.length = this.paginationProperty.totalItems
          // this.previousPageIndex = this.paginationProperty.previousPageIndex;
          // this.hasNextPage = this.paginationProperty.hasNextPage;
          // this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          // this.pageIndex = this.paginationProperty.pageNumber
          // this.dataSource1 = new MatTableDataSource(this.userlist);
          // this.dataSource1.sort = this.sort;
          // this.spinner.hide();
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.userlist.forEach(
            (value) => (value.postDate = value.postDate.slice(0, 10))
          );
          this.userdata = data;
          this.userlist = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;

          this.dataSource1 = new MatTableDataSource(this.userlist);
          this.dataSource1.sort = this.sort;
          //  this.dataSource.paginator = this.paginator;
          this.spinner.hide();
        });
    }
  }
  // pagination end
  onSubmit() {}
  // new code for api header count display
  getDiscussionboardHeader() {
    this._userService.getDiscussionBoardHeaderData().subscribe((data) => {
      this.totalUserCount = data;
      this.avgDiscussionquestionCount = this.totalUserCount.result.data;
    });
  }
}

@Component({
  selector: 'discussion-board-export-data',
  templateUrl: 'discussion-board-export-data.html',
})
export class DiscussionBoardExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<DiscussionBoardExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, value: 'Post Date', isSelected: false },
      { id: 2, value: 'Question', isSelected: false },
      { id: 3, value: 'Name', isSelected: false },
      { id: 4, value: 'State', isSelected: false },
      { id: 5, value: 'District', isSelected: false },
      { id: 6, value: 'Role', isSelected: false },
      { id: 7, value: 'View', isSelected: false },
      { id: 8, value: 'Like', isSelected: false },
      { id: 9, value: 'Replies', isSelected: false },
      { id: 10, value: 'Removed Date', isSelected: false },
      { id: 11, value: 'Removed by', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  onNoClick(): void {}
  ngOnInit(): void {
    this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
